// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-textarea-field[data-v-6e3ba6c8]{display:flex}.x-textarea-field[data-v-6e3ba6c8] .help-button{margin-top:2px}", ""]);
// Exports
module.exports = exports;
